const MappingRulesDescription = {
  regexHelper: 'In case you want to run a regular expression on the computed field before calculating the rate',
  mustMetHelper: 'This means than in case the condition is not met - a rate will not be found',
};

export default MappingRulesDescription;
